import type { Profile } from '../types/profile';
import type { TeamSummaryMember } from '../types/teamSummary';
import type { ClientAuditReportRow, ClientAuditInviteStatus, ClientAuditCertificationStatus } from '../types/clientAudit';

function resolveInviteStatus(status?: string, invitationAcceptedAt?: string | null): ClientAuditInviteStatus {
  if (status === 'pending') return 'pending';
  if (invitationAcceptedAt) return 'accepted';
  return status === 'active' ? 'accepted' : 'pending';
}

function resolveCertificationStatus(progress?: number): ClientAuditCertificationStatus {
  if (progress == null || progress <= 0) return 'not_started';
  if (progress >= 100) return 'complete';
  return 'in_progress';
}

export function profileToAuditRow(
  profile: Profile,
  teamId: string,
  teamName: string,
  teamMember?: TeamSummaryMember,
): ClientAuditReportRow {
  return {
    id: profile.id,
    displayName: profile.displayName || '—',
    email: profile.email || '—',
    inviteStatus: resolveInviteStatus(profile.status, profile.invitationAcceptedAt),
    lastLogin: profile.lastAuthentication ?? null,
    coursesCompleted: teamMember?.totalCoursesCompleted ?? 0,
    certificationPercent: teamMember?.progress ?? null,
    certificationStatus: resolveCertificationStatus(teamMember?.progress),
    teamId,
    teamName,
  };
}

export function sortAuditRows(rows: ClientAuditReportRow[]): ClientAuditReportRow[] {
  return [...rows].sort((a, b) => a.displayName.localeCompare(b.displayName));
}
